// extracted by mini-css-extract-plugin
export var dayLabel = "_l2-0";
export var pickerDisabled = "_l2-1";